import { useCallback, useEffect, useState } from 'react';
import useMetric from 'hooks/useMetric';
import metricTypeCheckers from 'types/metricTypeCheckers';
import { IPaceCalculateForExpressionArgs } from '../types';
import useBaseArgs from './useBaseArgs';
import useMetricAggregationRequest from 'hooks/useMetricAggregationRequest';

const useCompoundMetricArgs = ({
  paceMatrix,
}: {
  paceMatrix: VisualisationDefinitions.PaceMatrix;
}): IPaceCalculateForExpressionArgs | undefined => {
  const metric = useMetric(paceMatrix.metricId);
  const baseArgs = useBaseArgs({
    paceMatrix,
  });
  const { resolveMetricForRequest } = useMetricAggregationRequest();

  const getArgs = useCallback(():
    | IPaceCalculateForExpressionArgs
    | undefined => {
    if (!metric || !baseArgs || !metricTypeCheckers.isCompoundMetric(metric)) {
      return;
    }
    const resolved = resolveMetricForRequest(metric);
    // Not ready → an input metric is still loading; don't fire a partial
    // request (backend "parse error: Expected EOF").
    if (!resolved.ready || !resolved.expression) {
      return;
    }

    return {
      ...baseArgs,
      expression: resolved.expression,
      metrics: resolved.metricInputs,
    };
  }, [baseArgs, metric, resolveMetricForRequest]);
  const [args, setArgs] = useState<IPaceCalculateForExpressionArgs | undefined>(
    () => getArgs(),
  );
  useEffect(() => {
    setArgs(getArgs());
  }, [getArgs]);

  return args;
};

export default useCompoundMetricArgs;
